import { render } from "./Project.vue?vue&type=template&id=bbd08070"
import script from "./Project.vue?vue&type=script&lang=js"
export * from "./Project.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/scripts/view/portfolio/Project.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "bbd08070"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('bbd08070', __exports__)) {
    api.reload('bbd08070', __exports__)
  }
  
  module.hot.accept("./Project.vue?vue&type=template&id=bbd08070", () => {
    api.rerender('bbd08070', render)
  })

}


export default __exports__